export const READ_WRITE = 'READ_WRITE'
export const READ = 'READ'
export const WRITE = 'WRITE'

export type ReadWriteMode = typeof READ_WRITE | typeof READ | typeof WRITE
